// Detects when the page is being rendered by the build-time prerender script
// (script/prerender-ssr.ts). Components use this to suppress non-SEO chrome
// (cookie banner, install prompts, floating contact button) so snapshots stay
// focused on the indexable content.
//
// The flag is set via the `?__prerender=1` query string when Playwright visits
// each route. We require an exact value match (not just presence) so a stray
// `?__prerender` shared via copy-paste does not silently hide UI for visitors.
import {
  PRERENDER_URL_PARAM,
  PRERENDER_URL_VALUE,
} from "@shared/public-routes";

let cached: boolean | null = null;

export function isPrerendering(): boolean {
  if (cached !== null) return cached;
  if (typeof window === "undefined") {
    cached = false;
    return cached;
  }
  try {
    cached =
      new URLSearchParams(window.location.search).get(PRERENDER_URL_PARAM) ===
      PRERENDER_URL_VALUE;
  } catch {
    cached = false;
  }
  return cached;
}
